import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3C17.0054 3 16.0516 3.39509 15.3483 4.09835C14.6451 4.80161 14.25 5.75544 14.25 6.75V9.75C15.0456 9.75 15.8087 10.0661 16.3713 10.6287C16.9339 11.1913 17.25 11.9544 17.25 12.75V19.5C17.25 20.2957 16.9339 21.0587 16.3713 21.6213C15.8087 22.1839 15.0456 22.5 14.25 22.5H3.75C2.95435 22.5 2.19129 22.1839 1.62868 21.6213C1.06607 21.0587 0.75 20.2956 0.75 19.5V12.75C0.75 11.9544 1.06607 11.1913 1.62868 10.6287C2.19129 10.0661 2.95435 9.75 3.75 9.75H12.75V6.75C12.75 5.35761 13.3031 4.02226 14.2877 3.03769C15.2723 2.05312 16.6076 1.5 18 1.5C19.3924 1.5 20.7277 2.05312 21.7123 3.03769C22.6969 4.02226 23.25 5.35761 23.25 6.75V10.5C23.25 10.9142 22.9142 11.25 22.5 11.25C22.0858 11.25 21.75 10.9142 21.75 10.5V6.75C21.75 5.75544 21.3549 4.80161 20.6516 4.09835C19.9484 3.39509 18.9946 3 18 3ZM3.75 11.25C3.35218 11.25 2.97064 11.408 2.68934 11.6893C2.40804 11.9706 2.25 12.3522 2.25 12.75V19.5C2.25 19.8978 2.40804 20.2794 2.68934 20.5607C2.97064 20.842 3.35218 21 3.75 21H14.25C14.6478 21 15.0294 20.842 15.3107 20.5607C15.592 20.2794 15.75 19.8978 15.75 19.5V12.75C15.75 12.3522 15.592 11.9706 15.3107 11.6893C15.0294 11.408 14.6478 11.25 14.25 11.25H3.75Z"
        fill={colorValue}
      />
    </svg>
  );
};
